<main [ngClass]="theme">
    <div class="content">
        <app-viatim-icon></app-viatim-icon>
        <ng-content></ng-content>
    </div>
</main>
